module.exports = __webpack_public_path__ + "components/outside-promo-page/static/surfers-28465be75a2c770ec7551ccf3e20526e.webp";